const requestCache = new Map();

export async function fetchWithCache(url, options = {}) {
    const method = options.method || 'GET';
    // We only want to deduplicate GET requests
    if (method.toUpperCase() !== 'GET') {
        return fetch(url, options);
    }

    const key = url;

    if (requestCache.has(key)) {
        // Return the existing in-flight promise
        return requestCache.get(key).then(res => res.clone());
    }

    const promise = fetch(url, options)
        .then(res => {
            // Once the request completes, we leave it in the cache for 2 seconds 
            // to deduplicate any other components mounting at roughly the same time
            setTimeout(() => {
                requestCache.delete(key);
            }, 2000);
            return res;
        })
        .catch(err => {
            requestCache.delete(key);
            throw err;
        });

    requestCache.set(key, promise);
    
    // Return a clone so multiple callers can independently read the body
    return promise.then(res => res.clone());
}
